import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebSidenavContentComponent } from './web-sidenav-content.component';
import { MaterialModuleWeb } from '../material/material.module';
import { WebThemeModule } from '../web-theme/web-theme.module';
import { WebPagesModule } from '../web-pages/web-pages.module';
import { WebEntityModule } from '../web-entity/web-entity.module';
import { webAnalyticsModule } from '../web-analytics/web-analytics.module';
import { ApiCallsModule,appSettingsModule } from 'shared-library';



@NgModule({
  declarations: [
    WebSidenavContentComponent,
  ],
  imports: [
    CommonModule,
    MaterialModuleWeb,
    WebThemeModule,
    WebPagesModule,
    WebEntityModule,
    webAnalyticsModule,
    ApiCallsModule,
    appSettingsModule
  ],
  exports:[
    WebSidenavContentComponent
  ]
})
export class WebSidenavContentModule { }
